module.exports = __webpack_public_path__ + "img/AndreaKreinhacke_140x140.984032c6.jpg";